import React from "react";

const footerTranslations = {
  pt: {
    privacy: "Política de Privacidade",
    terms: "Termos de Uso",
    delete: "Excluir Conta",
    notice: "Este site respeita sua privacidade. Consulte nossa",
    and: "e",
  },
  en: {
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    delete: "Delete Account",
    notice: "This site respects your privacy. See our",
    and: "and",
  },
  es: {
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    delete: "Eliminar Cuenta",
    notice: "Este sitio respeta tu privacidad. Consulta nuestra",
    and: "y",
  },
};

const lang = localStorage.getItem("kitoLang") || navigator.language.slice(0, 2);
const t = footerTranslations[lang] || footerTranslations.pt;

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>
        {t.notice}{" "}
        <a href="/politica-de-privacidade" style={styles.link}>{t.privacy}</a>{" "}
        {t.and}{" "}
        <a href="/termo-de-uso" style={styles.link}>{t.terms}</a>.
      </p>

      <p style={styles.smallLink}>
        <a href="/delete-account" style={styles.subtleLink}>{t.delete}</a>
      </p>

      <p style={styles.meta}>
        &copy; {new Date().getFullYear()} KITO EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA · CNPJ: 57.276.139/0001-80
      </p>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "#FFF8E1",
    textAlign: "center",
    padding: "1.5rem 1rem",
    color: "#6D4C41",
    fontSize: "0.9rem",
    marginTop: "4rem",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    boxShadow: "0 -2px 5px rgba(0,0,0,0.05)",
  },
  text: {
    marginBottom: "0.25rem",
    fontSize: "clamp(0.8rem, 2.5vw, 0.95rem)",
  },
  smallLink: {
    margin: "0.3rem 0 0.8rem",
    fontSize: "clamp(0.7rem, 2vw, 0.85rem)",
  },
  meta: {
    margin: 0,
    fontSize: "clamp(0.75rem, 2vw, 0.9rem)",
    color: "#4E342E",
  },
  link: {
    color: "#028174",
    textDecoration: "none",
  },
  subtleLink: {
    color: "#6D4C41",
    textDecoration: "underline",
    opacity: 0.7,
  },
};
